exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.shop[data-v-0b6a8fe6] {\n  text-align: center;\n  overflow: hidden;\n}\nh2[data-v-0b6a8fe6] {\n  margin-top: 50px;\n}\n.inputBox[data-v-0b6a8fe6] {\n  display: inline-block;\n}\n\n", "", {"version":3,"sources":["/workspace/xiaoji/erp_view/src/page/Shop.vue"],"names":[],"mappings":";AA6GA;EACE,mBAAmB;EACnB,iBAAiB;CAClB;AAED;EACE,iBAAiB;CAClB;AAED;EACE,sBAAsB;CACvB","file":"Shop.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.shop {\n  text-align: center;\n  overflow: hidden;\n}\n\nh2 {\n  margin-top: 50px;\n}\n\n.inputBox {\n  display: inline-block;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b6a8fe6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/Shop.vue
// module id = iGLX
// module chunks = 487